define('../cloud-new/js/xray',['require','exports','module','../../common/js/xray','utils'],function(require, exports, module) {
    var sendDwh = require('../../common/js/xray');
    var utils = require('utils');

    var utm_source = utils.getParameterByName('utm_source');
    var utm_term = utils.getParameterByName('utm_term');
    var utm_medium = utils.getParameterByName('utm_medium');
    var utm_campaign = utils.getParameterByName('utm_campaign');
    var from = utils.getParameterByName('from');

    var sendPromoXray = function(action, label, version) {
        var dwhParams = {
            version: version,
            source: 'desktop',
            utm_source: utm_source,
            utm_term: utm_term,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
            from: from
        };

        if (window.location.pathname.includes('summer')) {
            return;
        }

        sendDwh('landing-promo', action, label, true, dwhParams);
    };

    module.exports = {
        sendPromoXray: sendPromoXray
    };
});

